<!--
 * @Author: qiye@yscredit.com
 * @Date: 2020-05-18 16:18:09
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-25 10:19:48
 * @Description: 通知列表
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-serach">
        <el-input
          v-model="videoName"
          placeholder="请输入视频名称"
          @keyup.enter.native="getSearch"
        >
          <i
            @click="getSearch"
            slot="suffix"
            class="el-input__icon el-icon-search"
          ></i
        ></el-input>
        <span>审核状态：</span>
        <el-select
          v-model="status"
          placeholder="所有类别"
          @change="getPoss"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="addPru" @click="add">新增</div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
      <el-table-column
        prop="videoName"
        label="视频名称"
        width="250"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="videoType"
        align="center"
        label="视频类型"
      ></el-table-column>
      <el-table-column
        prop="creator"
        align="center"
        label="上传者"
      ></el-table-column>
      <el-table-column prop="status" align="center" label="状态">
        <template slot-scope="scope">
          <div>
            <span
              v-if="scope.row.status == 1"
              style="
                width: 8px;
                height: 8px;
                background: rgb(0,168,84);
                display: inline-block;
                border-radius: 50%;
              "
            ></span>
            <span
              v-else-if="scope.row.status == 0"
              style="
                width: 8px;
                height: 8px;
                background: #D8D8D8;
                display: inline-block;
                border-radius: 50%;
              "
            ></span>
            <span
              v-else
              style="
                width: 8px;
                height: 8px;
                background: red;
                display: inline-block;
                border-radius: 50%;
              "
            ></span>
            {{ videoStatus(scope.row.status) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoIntroduction"
        label="视频简介"
        width="350"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        label="上传时间"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            :class="[scope.row.onStatus ? 'actcolor' : 'nocolor']"
            style="cursor: pointer; margin-right: 10px; margin-left: -10px"
            @click="shelf(scope.row, 0)"
            >上架</span
          >
          <span
            :class="[!scope.row.onStatus ? 'actcolor' : 'nocolor']"
            style="margin-right: 10px; cursor: pointer"
            @click="shelf(scope.row, 1)"
            >下架</span
          >
          <span
            style="
              color: #1890ff;
              cursor: pointer;
              margin-left: 10px;
            "
            @click="videoDetail(scope.row)"
            >查看</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listVideoData, updateVideoStatus } from '@api/video/video'
export default {
  data() {
    return {
      videoName: '', // 视频名称
      status: '', // 所有类别
      options: [
        { value: '', label: '全部' },
        { value: 0, label: '待审核' },
        { value: 1, label: '通过' },
        { value: 2, label: '驳回' }
      ], // 所有类别数据
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      paginationBoxReflow: true,
      repeat: false
    }
  },
  watch: {},
  computed: {
    videoStatus() {
      return number => {
        let val
        switch (number) {
          case 0:
            val = '待审核'
            break
          case 1:
            val = '通过'
            break
          case 2:
            val = '驳回'
            break
        }
        return val
      }
    }
  },
  methods: {
    // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listVideoData()
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listVideoData()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      console.log(e)
      this.listVideoData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listVideoData()
    },
    // 新增
    add() {
      this.$router.push({ name: 'addVideo' })
    },
    /** 上架下架 */
    shelf(val, number) {
      if (val.isDeploy == number) {
        if (number) {
          this.$message('该活动已上架')
          return false
        } else {
          this.$message('该活动已下架')
          return false
        }
      }
      updateVideoStatus({ id: val.id, status: number }).then(res => {
        if (res.data.code == '0000') {
          this.$message.success(!number ? '上架成功' : '下架成功')
          this.listVideoData()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 列表
    listVideoData() {
      let par = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        videoName: this.videoName,
        status: this.status
      }
      listVideoData(par).then(res => {
        if (res.data.code == '0000') {
          let list = res.data.data
          this.tableData = list.results || []
          this.totalRecord = list.totalRecord || 0
        }
      })
    },
    // // 编辑
    // getDetail(val) {
    //   this.$router.push({ name: 'addVideo', query: { id: val.id } })
    // },
    // Detail
    videoDetail(val) {
      this.$router.push({ name: 'UploadDetail', query: { id: val.id } })
    }
  },
  mounted() {
    this.listVideoData()
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  margin-bottom: 20px;
  .header-serach {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
}
.actcolor {
  color: #1890ff;
}
.nocolor {
  color: rgba(0, 0, 0, 0.3);
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
</style>
